const units = ["B", "KB", "MB", "GB"];

export const humanSize = (bytes, precision = 0) => {
  const magnitude = Math.min((Math.log(bytes) / Math.log(1024)) | 0, units.length - 1);
  const result = bytes / Math.pow(1024, magnitude);
  const suffix = units[magnitude];
  return `${result.toFixed(precision)} ${suffix}`;
};
